import styled from "styled-components";

import { Link as LinkDefault } from "ds/Button";
import { semiBoldAlias } from "Libs/theme";

export const Link = styled(LinkDefault)`
  ${semiBoldAlias()}
`;

export const ContentWrapper = styled.div`
  display: grid;
  gap: 16px;
`;
